module.exports = __webpack_public_path__ + "img/off.779ef4bf.svg";